module.exports = __webpack_public_path__ + "static/img/logo-2.0f077f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-2.png
// module id = Nko+
// module chunks = 1